import { HIGHLIGHT_WORDS_FOR_QUESTION } from '@/constant';
import { type FragmentType, useFragment } from '@/gql/codegen';
import { graphql } from '@/gql/codegen/gql';
import { highlightText } from '@/utils/highlighter';
import { safeHtml } from '@/utils/safeHtml';
import type React from 'react';
import styles from './index.module.scss';

export const COURSE_SKILL_CHECK_TEST_QUESTION_DETAIL = graphql(/* GraphQL */ `
  fragment EmbaCourseSkillCheckTestQuestionDetail on SkillCheckTestQuestion {
    id
    ordinal
    content
    questionType
    attachmentImage
    choices{
      id
      content
    }
  }
`);

export type QuestionListItemProps = {
  question: FragmentType<typeof COURSE_SKILL_CHECK_TEST_QUESTION_DETAIL>;
  handleSingleChoiceChange: (questionId: number, choiceId: number) => void;
  handleMultipleChoiceChange: (questionId: number, choiceId: number) => void;
};

export const QuestionListItem: React.FC<QuestionListItemProps> = ({
  question,
  handleSingleChoiceChange,
  handleMultipleChoiceChange,
}) => {
  const questionData = useFragment(
    COURSE_SKILL_CHECK_TEST_QUESTION_DETAIL,
    question,
  );

  return (
    <li key={questionData.id} className={styles.question}>
      <div className={styles.questionLabelArea}>
        <p className={styles.questionLabel}>問{questionData.ordinal}</p>
      </div>
      <p
        className={styles.questionContent}
        // biome-ignore lint/security/noDangerouslySetInnerHtml: サニタイズ済みのHTMLを表示するため
        dangerouslySetInnerHTML={{
          __html: safeHtml(
            highlightText(questionData.content, HIGHLIGHT_WORDS_FOR_QUESTION),
          ),
        }}
      />

      {questionData.attachmentImage && (
        <div className={styles.attachmentImageArea}>
          <img src={questionData.attachmentImage} alt="" />
        </div>
      )}
      <ul className={styles.questionChoices}>
        {questionData.choices.map((choice) => (
          <li key={choice.id} className={styles.questionChoice}>
            {questionData.questionType === 'single_choice' ? (
              <input
                type="radio"
                id={`choice-${choice.id}`}
                name={`question-${questionData.id}`}
                value={choice.id}
                onChange={() =>
                  handleSingleChoiceChange(questionData.id, Number(choice.id))
                }
              />
            ) : (
              <input
                type="checkbox"
                id={`choice-${choice.id}`}
                name={`question-${questionData.id}`}
                value={choice.id}
                onChange={() =>
                  handleMultipleChoiceChange(questionData.id, Number(choice.id))
                }
              />
            )}
            <label
              htmlFor={`choice-${choice.id}`}
              className={styles.questionChoiceLabel}
            >
              {choice.content}
            </label>
          </li>
        ))}
      </ul>
    </li>
  );
};
